import { Link } from "react-router-dom";
import { cx } from "./ui";

// Pie con los botones obligatorios (Ley 24.240 art. 34 y 10 ter; Disposición 954/2025): en todas las páginas,
// también sin sesión.
export default function LegalFooter({ className }) {
  return (
    <footer className={cx("border-t border-slate-200 bg-white/80 print:hidden", className)}>
      <nav aria-label="Arrepentimiento y baja" className="mx-auto flex max-w-7xl flex-wrap items-center justify-center gap-x-6 gap-y-2 px-4 py-4 text-xs sm:px-6">
        <Link to="/arrepentimiento" className="font-semibold text-slate-600 underline-offset-2 hover:text-brand-700 hover:underline">
          Botón de Arrepentimiento
        </Link>
        <Link to="/baja" className="font-semibold text-slate-600 underline-offset-2 hover:text-brand-700 hover:underline">
          Botón de Baja de Servicio
        </Link>
        <span className="text-slate-400">© OdontoSend</span>
      </nav>
    </footer>
  );
}
